import { getRequest, postRequest } from "../config/AxiosConfig"
import API_URLS from "../config/BackendConfig";
import { getToken } from "../utils/tokenUtils";
const custUrl = API_URLS.CUSTOMER;
const getAuthHeaders = () => {
    const token = getToken();

    return token ? { Authorization: `Bearer ${token}` } : {};
  };

export const verifyIfscCodeService =async (ifsc) => {
    try {
        let response = await getRequest({
            url: 'https://ifsc.razorpay.com/' + ifsc
        });
        return response;
    } catch (error) {
        return error
    }
}

export const getServiceNameAndDetails = async (payload) => {
  try {
    const response = await postRequest({
      url: `${custUrl}service/list-name`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getServiceDetailForBulk= async (payload) => {
  try {
    const response = await postRequest({
      url: `${custUrl}service-details/userid-service`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};


